import { axiosObj } from "./axios";
 
 
//Getting all tribe
export const getAllLesson = async (offset: string, count: string, accessToken: string): Promise<any> => {
    const TribeByIdData = axiosObj.get(`/lessons?offset=${offset}&count=${count}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        }
    });
    return (await TribeByIdData).data
};
 
export const addNewLesson = async (formData: FormData, accessToken: string): Promise<any> => {
    const updatedTribeResponse = axiosObj.post(`/lessons/createLesson`, formData, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "multipart/form-data",
        },
    });
    return (await updatedTribeResponse).data
}
 
//Updating the tribe
export const updateLesson = async (formData: FormData, accessToken: string): Promise<any> => {
    const updatedTribeResponse = axiosObj.put(`/lessons/updateLesson`, formData, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "multipart/form-data",
        },
    });
    return (await updatedTribeResponse).data
};
 
//Updating the tribe
export const getLessonByID = async (lessonId: string, accessToken: string): Promise<any> => {
    const updatedTribeResponse = axiosObj.get(`/lessons/${lessonId}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        },
    });
    return (await updatedTribeResponse).data
};
 
//Updating the tribe
export const deleteLessonByID = async (lessonId: string, accessToken: string): Promise<any> => {
    const updatedTribeResponse = axiosObj.delete(`/lessons/${lessonId}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        },
    });
    return (await updatedTribeResponse).data
};
 
//Updating the tribe
export const deleteUnitByID = async (unitId: string, accessToken: string): Promise<any> => {
    const updatedTribeResponse = axiosObj.delete(`/units/${unitId}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        },
    });
    return (await updatedTribeResponse).data
};
 
//Search Tribe by tribe name with offset limit and Count 
export const searchLesson = async (searchText: string, status: string, gradeId: string, startDate: string | null, endDate: string | null, offset: string,
    count: string, accessToken: string) => {
    const queryParams = new URLSearchParams();
 
    if (searchText) queryParams.append("name", searchText);
    if (status) queryParams.append("isActive", status);
    if (gradeId) queryParams.append("grade", gradeId);
    if (startDate) queryParams.append("start_date", startDate);
    if (endDate) queryParams.append("end_date", endDate);
    queryParams.append("offset", offset);
    queryParams.append("count", count);
 
    const url = `lessons/searchLessonByFilter?${queryParams.toString()}`;
 
    try {
        const response = await axiosObj.get(url, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            },
        });
 
        return response.data;
    } catch (error) {
        console.error("Error in searchTribe API:", error);
        throw error;
    }
};
 
export const getAllLessonWithoutOffset = async () => {
    const TribeByIdData = axiosObj.get(`/lessons/findAllLesson`, {
        headers: {
            "Content-Type": "application/json",
        }
    });
    return (await TribeByIdData).data
}
 
export const checkLessonNameExist = async (lessonId: string, gradeId: string, lessonName: string, tribeId: string) => {
        // Build query parameters dynamically
        const queryParams = new URLSearchParams();
 
        if (lessonId) queryParams.append("lessonId", lessonId);
        if (lessonName) queryParams.append("name", lessonName);
        if (tribeId) queryParams.append("tribeId", tribeId);
        if (gradeId) queryParams.append("gradeId", gradeId);
        const CheckLessonNameData = axiosObj.get(`/lessons/checkLessonName?${queryParams.toString()}`, {
            headers: {
                "Content-Type": "application/json",
            }
        });
        return (await CheckLessonNameData).data
}
 
 
export const checkUnitNameExist = async (lessonId: string, unitName: string) => {
    const CheckUnitNameData = axiosObj.get(`/units/checkUnitName/${unitName}/${lessonId}`, {
        headers: {
            "Content-Type": "application/json",
        }
    });
    return (await CheckUnitNameData).data
}
 
 
//Updating the tribe
export const updateUnit = async (formData: FormData, accessToken: string): Promise<any> => {
    const updatedUnitResponse = axiosObj.put(`/units/updateUnit`, formData, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "multipart/form-data",
        },
    });
    return (await updatedUnitResponse).data
};